'use strict'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { titleName, viewId } from '../../../_constants/Code'
import Forbidden from '../../../_components/Forbidden'
import JudgmentRuleListContent from './JudgmentRuleListContent'

/** 判定ルール一覧画面 */
const JudgmentRuleList = () => {
  const state = useSelector((state) => state)

  // 権限チェック
  if (
    !state.authority.Master_AuthInfo.Availability ||
    !state.authority.Master_AuthInfo.Auth_Conf.DataMapping.JudgmentRule_Set
  ) {
    return <Forbidden />
  }

  return (
    <JudgmentRuleListContent
      pageTitle={titleName.judgmentRuleList + titleName.common}
      corporationNumber={state.company.corporationNumber}
      userId={state.user.sub}
      authority={state.authority}
    />
  )
}

export default JudgmentRuleList
